import { Untracked } from '@hookstate/untracked';
import * as React from 'react';
import { useAtomValue } from 'jotai';
import { subscribeToMailchimpNewsLetter } from '../../../../../../mailchimp';
import {
  newsLetterState, newsLetterSubmitErrorState, newsLetterSubmitSuccessState, newsLetterSubmittingState, resetNewsLetterStates, validateNewsLetterSync,
} from '../../../../state';
import { pathnameUrlLanguageAtom } from '../../../../../../history';

export const NewsLetterBoxFormContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const language = useAtomValue(pathnameUrlLanguageAtom);
  const onSubmit = React.useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    newsLetterSubmittingState.set(true);
    newsLetterSubmitErrorState.set(null);
    const valid = validateNewsLetterSync({ touch: true });
    if (valid) {
      const {
        firstName,
        lastName,
        email,
      } = Untracked(newsLetterState).get();
      subscribeToMailchimpNewsLetter({
        language,
        firstName,
        lastName,
        email,
      }).then(() => {
        newsLetterSubmitErrorState.set(null);
        newsLetterSubmitSuccessState.set(true);
        resetNewsLetterStates();
      }).catch((err) => {
        newsLetterSubmitErrorState.set(err);
      }).finally(() => {
        newsLetterSubmittingState.set(false);
      });
    }
  }, [language]);
  return (
    <form onSubmit={onSubmit}>
      {children}
    </form>
  );
};
